import { Flex } from "@chakra-ui/react";
import Layout from "../components/Layout";
import ContactForm from "../components/ContactForm";

let Contact = ({ global }) => {
  return (
    <Layout global={global}>
      <Flex>
        <ContactForm />
      </Flex>
    </Layout>
  );
};

export default Contact;
